<template>
  <McForm
    ref="mcFormInstance"
    :loading="tracker == null"
    v-bind="$attrs"
    @completed="e => $emit('completed', e)"
    :onSubmit="handleSubmit"
    :submiticon="'check'"
    :title="$t('trackers.ReportStolen')"
    :submittext="tracker && tracker.insurerGranted ? $t('trackers.ExtendAccess') : $t('trackers.GiveAccess')"
  >
    <template v-if="tracker && tracker.insurerName">
      <i18n path="trackers.ReportStolenDescription" tag="p">
        <template v-slot:insurancename><strong>{{ tracker.insurerName }}</strong></template>
      </i18n>
      <p><strong class="text-danger">{{ $t('trackers.ReportStolenDescription2') }}</strong></p>
      <i18n v-if="tracker.insurerGranted" path="trackers.InsurerAccessEnabledUntil">
        <template v-slot:accessExpires>
          <TnLocalTime class="badge badge-dark" :time="tracker.insurerGrantUntil" format="l LT" />
        </template>
      </i18n>
      <!--pre> {{ tracker.imei }} </pre>
      <pre> {{ tracker.name }} </pre>
      <pre> {{ tracker.insurerGrantUntil }} </pre-->
    </template>
  </McForm>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import TrackerService from '../services/TrackerService'

export default {
  components: {},
  data() {
    return {
      tracker: null,
    }
  },
  created() {
    this.loadingState = false
  },
  computed: {
    ...mapState('LoginStore', ['status']),
    ...mapState({
      LanguageStore: state => state.LanguageStore,
    }),
  },
  $_veeValidate: {
    validator: 'new', // give me my own validator scope.
  },
  methods: {
    ...mapActions('ToastStore', [
      'toastSuccess', //
    ]),
    setTracker(tracker) {
      this.$refs['mcFormInstance'].forceReset()
      this.tracker = tracker
    },

    handleSubmit(e) {
      return TrackerService.grantInsurer(this.tracker.imei, 7).then(
        data => {
          this.toastSuccess(this.$t('trackers.AccessGranted'))
          return Promise.resolve(data)
        },
        error => {
          console.error('Error reporting tracker stolen', error)
          return Promise.reject(error)
        },
      )
    },
  },
}
</script>
